import React from 'react'
import styled, { keyframes } from 'styled-components'
import { Box } from '..'

const rotate = keyframes`
  to {
    transform: rotate(360deg);
  }
`

const Spinner = styled.div`
  border: 8px solid transparent;
  border-left-color: #212366;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  margin: auto;
  animation: ${rotate} 1s linear infinite;
`

const Loading: React.FC = () => {
  return (
    <Box my={[60, 60, 120]}>
      <Spinner />
    </Box>
  )
}

export default Loading
